module.exports = __webpack_public_path__ + "img/no_data_item.2a05e711.png";